<template>
    <line-chart v-if="loadedChart" :chartData="chartData" :options="options" :height="200"/>
</template>

<script>
    import StudentService from '@/taskflex/students/services/StudentService';
    import CustomerService from '@/taskflex/customers/services/CustomerService';
    import LineChart from '@/global/components/charts/LineChart';

    export default {
        data() {
            return {
                chartData: {
                    labels: [],
                    datasets: [
                    ],
                },

                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                stepSize: 5,
                                max: 50,
                                min: 0,
                            },
                        }],
                    },
                },
            };
        },

        mounted() {
            this.loadChart();
        },

        props: {
            period: {
                type: String,
                required: true,
            },

            from: {
                type: String,
                required: true,
            },

            to: {
                type: String,
                required: true,
            },
        },

        watch: {
            period() {
                this.chartData.labels = [];
                this.chartData.datasets = [];
            },
        },

        computed: {
            loadedChart() {
                return this.chartData.datasets.length === 2;
            },
        },

        methods: {
            loadChart() {
                const options = {
                    period: this.period,
                    from: this.from,
                    to: this.to,
                };

                StudentService.sumByDatePeriod(options, ({ data }) => {
                    this.setChartDateSet('students', data, '#f87979');
                });

                CustomerService.sumByDatePeriod(options, ({ data }) => {
                    this.setChartDateSet('customers', data, '#352cf8');
                });
            },

            setChartDateSet(dateSetName, data, color) {
                // Add labels if not added yet.
                if (this.chartData.labels.length === 0) {
                    this.chartData.labels = Object.keys(data);
                }

                // Add the dataset
                this.chartData.datasets.push({
                    label: dateSetName,
                    borderColor: color,
                    backgroundColor: color,
                    data: Object.values(data),
                    fill: false,
                });
            },
        },

        components: {
            LineChart,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/OverviewChart.vue